// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1NCAz","disabled":"FileBtn_disabled__3SnNa","warn":"FileBtn_warn__2Byl1","fade":"FileBtn_fade__3ou14"};